// let prod = "https://com-sparkle-sparkle.herokuapp.com/api"
// let dev = "https://com-sparkle-stage.herokuapp.com/api"
// let local = "http://localhost:8001/api"


let API = `https://sparkle-sandbox.onrender.com/api`

export { API }
